import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-product-placement',
  templateUrl: './product-placement.component.html',
  styleUrls: ['./product-placement.component.scss'],
  imports: [TranslatePipe],
})
export class ProductPlacementComponent {}
